// extracted by mini-css-extract-plugin
export var bounce = "_og-1";
export var generatingText = "_og-6";
export var lightning = "_og-4";
export var popup = "_og-5";
export var progressBar = "_og-7";
export var progressFill = "_og-8";
export var progressShimmer = "_og-9";
export var progressText = "_og-a";
export var shimmer = "_og-3";
export var uploadIcon = "_og-0";
export var uploadingText = "_og-2";